import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

let seoCache = null;

export const useSEO = (pagePath) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const applySEO = async () => {
      try {
        if (!seoCache) {
          const res = await axios.get(`${API}/seo`);
          seoCache = res.data.seo || {};
        }

        const seo = seoCache[pagePath];
        if (seo) {
          document.title = seo.title || 'Tropiluxe';

          let metaDesc = document.querySelector('meta[name="description"]');
          if (!metaDesc) {
            metaDesc = document.createElement('meta');
            metaDesc.setAttribute('name', 'description');
            document.head.appendChild(metaDesc);
          }
          metaDesc.setAttribute('content', seo.description || '');
        }
      } catch (e) {
        // Silently fail — defaults are fine
      }
      setLoaded(true);
    };

    applySEO();
  }, [pagePath]);

  return loaded;
};

// Clear cache when admin updates SEO
export const clearSEOCache = () => {
  seoCache = null;
};
